<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/create-food-vendor">Create Vendor</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">View Vendors</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">View Vendors</h2>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h5 class="font-weight-medium mb-3 mb-md-4" style="color: #004988;">Food Court Name: {{foodCourtName}}</h5>
        <button class="btn btn-primary" (click)="addNewVendor()">Add Vendor</button>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
                    (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Operation Status</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedVendorName}}</div>
                    <ng-template #popContent>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let group of getFilteredVendorTypes(); let i=index"
                                    [ngClass]="(multiSelectGroup == group?.vendorTypeName || (group.vendorTypeName == null && multiSelectGroup.length == 0)) && 'active'"
                                    (click)="selectVendorType(group)">
                                    {{group?.vendorTypeName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroup == group?.vendorTypeName || (group.vendorTypeName == null && multiSelectGroup.length == 0)"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-9 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}} Vendor{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="foodvendorRemove">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedVendor" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModalRemoveVendor(onlyVendorIds)">Remove Selected</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let vendor of newmainVendorList | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainVendorList?.length }; let i=index">
            <div class="bg-lighter p-3 rounded d-flex align-items-center column-gap-2 h-100">
                <div class="custom-control custom-checkbox flex-shrink-0 mt-1" *ngIf="foodvendorRemove">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="vendor.isSelected" name="list_name"
                        [id]="vendor.foodCourtVendorId + 'list_name'" value="{{vendor.foodCourtVendorId}}"
                        (change)="isAllSelected()">
                    <label [for]="vendor.foodCourtVendorId + 'list_name'"
                        class="custom-control-label cursor-pointer"></label>
                </div>
                <div>
                    <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer"
                        (click)="goToVendorDetails(vendor.foodCourtVendorId)">
                        {{vendor.foodCourtVendorName}}</h3>
                    <p class="small mb-1" *ngIf="vendor.isMarkClosed==false">Operation Status: <strong
                            class="text-success">Opened</strong></p>
                    <p class="small mb-1" *ngIf="vendor.isMarkClosed==true">Operation Status: <strong
                            class="text-danger">Closed</strong></p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainVendorList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelVendorList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainVendorList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(mainSurveyList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>
</div>